import React from 'react';
import { AppImage } from './AppImage';
import { Container } from './Container';
import { ImageBackdrop } from './ImageBackdrop';
import { Reveal } from './Reveal';
interface PageIntroImage {
  src: string;
  alt: string;
}
interface PageIntroProps {
  eyebrow: string;
  title: string;
  lede: string;
  image?: PageIntroImage;
  imageBackdrop?: boolean;
}
export function PageIntro({
  eyebrow,
  title,
  lede,
  image,
  imageBackdrop = false
}: PageIntroProps) {
  return <section className="relative isolate overflow-hidden bg-canvas pb-16 pt-[96px] lg:pb-24 lg:pt-[152px]" data-id="element-662" data-mp="3qvqsok2aivsb">
      {image && imageBackdrop && <ImageBackdrop src={image.src} opacityClass="opacity-[0.05]" blurClass="blur-[40px]" overlayClass="bg-white/40" data-id="element-663" data-mp="3hxojhh8ekwty" />}
      <Container className="relative z-10" data-id="element-664" data-mp="26hzvcmjexrrk">
        <Reveal data-id="element-665" data-mp="26g5b7afyu3oj">
          {image ? <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-666" data-mp="2bgtb6lm69uuw">
              <div className="lg:col-span-7" data-id="element-667" data-mp="2beqczeav8vf3">
                <p className="text-small text-muted" data-id="element-668" data-mp="18u2r8ybdeocs">{eyebrow}</p>
                <h1 className="mt-5 max-w-[18ch] font-serif text-[clamp(40px,5vw,72px)] font-normal leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-669" data-mp="13vsu4i635doj">
                  {title}
                </h1>
                <p className="mt-8 max-w-[54ch] text-body text-muted" data-id="element-670" data-mp="1iqpaxjryn9d8">{lede}</p>
              </div>
              <AppImage src={image.src} alt={image.alt} ratio="16:10" className="lg:col-span-5" data-id="element-671" data-mp="1dwbklvs5nsff" />
            </div> : <>
              <p className="text-small text-muted" data-id="element-672" data-mp="1mtlylowcxvo1">{eyebrow}</p>
              <h1 className="mt-5 max-w-[18ch] font-serif text-[clamp(40px,5vw,72px)] font-normal leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-673" data-mp="21jjny860wret">
                {title}
              </h1>
              <p className="mt-8 max-w-[54ch] text-body text-muted" data-id="element-674" data-mp="1wmt0v0vswvjw">{lede}</p>
            </>}
        </Reveal>
      </Container>
    </section>;
}